// extracted by mini-css-extract-plugin
export var primitiveLabel = "_tt-0";